<template>
    <q-dialog ref="dialog" @hide="onDialogHide" persistent>
        <q-card class="q-dialog-plugin " style="width: 30vw; max-width: 90vw;">
            <q-toolbar class="bg-primary text-white">
                <q-toolbar-title v-text="(actionTitle + ' ' + screenTitle).trim()"></q-toolbar-title>
                <q-btn flat round dense icon="close" v-close-popup></q-btn>
            </q-toolbar>

            <q-form ref="modelForm">
                <q-card-section>
                    <div class="flex column wrap">
                        <div class="row q-col-gutter-lg">
                            <div class="col-12">
                                <q-input v-model="model.PortalName" type="text"
                                         label="Portal name *"
                                         :rules="[val => val && val.length > 0 || 'Required',]"
                                         :error="fieldHasError('PortalName')"
                                         :error-message="fieldErrorMessage('PortalName')"
                                         dense>


                                </q-input>
                            </div>
                            <div class="col-12">
                                <q-input v-model="model.DomainName" type="text"
                                         label="Domain *" :suffix="model.DomainSuffix"
                                         autofocus
                                         :rules="[val => val && val.length > 0 || 'Required',]"
                                         :error="fieldHasError('DomainName')"
                                         :error-message="fieldErrorMessage('DomainName')"
                                         dense>


                                </q-input>
                            </div>
                            <div class="col-12">
                                <q-select v-model="model.WarehousePlugin"
                                          label="Warehouse plugin"
                                          :options="dataSourceLookupTechShipWarehousePlugins" option-value="Key" option-label="Value"
                                          emit-value map-options
                                          :rules="[]"
                                          :error="fieldHasError('WarehousePlugin')"
                                          :error-message="fieldErrorMessage('WarehousePlugin')"
                                          @input="onWarehousePluginChange(model, ...arguments)"
                                          dense options-dense>


                                </q-select>
                            </div>
                            <div class="col-12">
                                <q-select v-model="model.ChargeBeeSubscriptionId"
                                          label="ChargeBee subscription *"
                                          :options="dataSourceLookupTechShipSubscriptions" option-value="Key" option-label="Value"
                                          emit-value map-options
                                          :rules="[val => !!val || 'Required',]"
                                          :error="fieldHasError('ChargeBeeSubscriptionId')"
                                          :error-message="fieldErrorMessage('ChargeBeeSubscriptionId')"
                                          @input="onChargeBeeSubscriptionIdChange(model, ...arguments)"
                                          dense options-dense>


                                </q-select>
                            </div>
                            <div class="col-12">
                                <q-select v-model="model.Timezone"
                                          label="Timezone *"
                                          :options="dataSourceLookupTimeZones" option-value="Key" option-label="Value"
                                          emit-value map-options
                                          :rules="[val => !!val || 'Required',]"
                                          :error="fieldHasError('Timezone')"
                                          :error-message="fieldErrorMessage('Timezone')"
                                          @input="onTimezoneChange(model, ...arguments)"
                                          dense options-dense>


                                </q-select>
                            </div>
                            <div class="col-12">
                                <q-input v-model="model.AdminUser" type="text"
                                         label="Admin user *"
                                         :rules="[val => val && val.length > 0 || 'Required',]"
                                         :error="fieldHasError('AdminUser')"
                                         :error-message="fieldErrorMessage('AdminUser')"
                                         dense>


                                </q-input>
                            </div>
                            <div class="col-12">
                                <q-select v-model="model.Carriers"
                                          label="Carriers"
                                          :options="dataSourceLookupTechShipCarriers" option-value="Key" option-label="Value"
                                          emit-value map-options multiple
                                          :rules="[]"
                                          :error="fieldHasError('Carriers')"
                                          :error-message="fieldErrorMessage('Carriers')"
                                          @input="onCarriersChange(model, ...arguments)"
                                          dense options-dense>


                                </q-select>
                            </div>

                        </div>
                    </div>
                </q-card-section>
            </q-form>

            <q-toolbar>
                <div class="q-gutter-xs">

                </div>

                <q-space></q-space>

                <div class="q-gutter-xs" v-if="editMode === true">
                    <q-btn color="primary" :label="actionLabel" @click="onOkClick"></q-btn>
                    <q-btn color="white" text-color="black" label="Cancel" @click="onCancelClick"></q-btn>
                </div>
                <div class="q-gutter-xs" v-if="editMode === false">
                    <q-btn color="white" text-color="black" label="Close" @click="onCancelClick"></q-btn>
                </div>
            </q-toolbar>

            <q-inner-loading :showing="loading">
                <q-spinner-gears size="50px" color="primary"></q-spinner-gears>
            </q-inner-loading>
        </q-card>
    </q-dialog>
</template>

<style>
</style>

<script>
    export { default } from './techshipportaladdmodel-dialog-screen.js'
</script>